import React, { Component } from 'react';
import axios from 'axios';
import $ from 'jquery';

import './App.css';

import Header from './misc/Header';
import Footer from './misc/Footer';
import Error from './misc/Error';
import Loading from './misc/Loading';
import Lost from './misc/Lost';
import Radison from './misc/Radison';
import IndexSurvey from './surveys/Index';

import runtimeEnv from '@mars/heroku-js-runtime-env';
import OptInSplash from './surveys/OptInSplash';
import OptInQr from './surveys/OptInQr';
const env = runtimeEnv();

var API_BASE = env.REACT_APP_API_URL;

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    window.jQuery.material.init();
    var url = window.location.pathname.split('/');
    const hotel_id = url[2];

    console.log(env.REACT_APP_ENV);
    if (hotel_id) {
      this.setState({ hotel_id, through_qr: !this.isParamEnabled("old", "true"), is_qr: this.isParamEnabled("qr", "true")}, this.loadHotel);
    } else {
      this.setState({ hotel_id: null });
    }
  }

  loadHotel() {
    var hotel_id = this.state.hotel_id;
    if (!hotel_id.includes('radisson-red-brussels')) {
      axios
      .get(`${API_BASE}/hotels/${hotel_id}.json`)
      .then((resp) => {
        // const { hotel, feedback_survey, guest_survey } = resp.data;
        const { hotel, guest_survey } = resp.data;
        this.setState({
          hotel: hotel,
          feedback_survey: '{}',
          guest_survey: guest_survey
        });
      })
      .catch((err) => {
        this.setState({hotel_id: -1})
      });
    }
  }

  isParamEnabled(param, value) {
    const query = window.location.search;
    return query.includes(param) && query.includes(value);
  }

  currentStep() {
    const { hotel_id, hotel } = this.state;

    if(hotel_id == null || hotel_id == -1 || (hotel && hotel.wifi_welcome_settings.enabled == "false" )) {
      return 'ERROR';
    }

    if (hotel_id && hotel) {
      if (this.state.through_qr) {
        return 'OPT_IN_SPLASH';

      } else if (this.state.is_qr) {
        return 'OPT_IN_QR';

      } else {
        return 'INDEX';

      }
    }

    return 'INITIAL';
  }

  renderContent() {
    switch(this.currentStep()) {
      case 'INITIAL':
       return <Loading />;

      case 'INDEX':
        return <IndexSurvey hotel={this.state.hotel} feedback_survey={this.state.feedback_survey} guest_survey={this.state.guest_survey} />;

      case 'OPT_IN_QR':
        return <OptInQr hotel={this.state.hotel} />;

      case 'OPT_IN_SPLASH':
        return <OptInSplash hotel_id={this.state.hotel.id} settings={this.state.hotel.wifi_welcome_settings} />;

      case 'ERROR':
        return <Error details="Hotel not found" />;

      default:
        return <Lost />;
    }
  }

  checkElementValue(name_values) {
    let survey = this.state.guest_survey;
    let match_count = 0;
    let pairs = name_values.trim().split(',');
    pairs.forEach((name_value) => {
      let name = name_value.split(':')[0];
      let value = name_value.split(':')[1];
      if (survey && survey["pages"][0] && survey["pages"][0]["elements"]) {
        survey["pages"][0]["elements"].filter((s) => { return s[name] === value }).length > 0 ? match_count++ : '';
      }
    })

    return [0, pairs.length].includes(match_count);
  }

  render() {

    if(this.state.hotel && this.state.hotel.wifi_welcome_settings.background_url !== "") {
      document.body.style.backgroundImage = "url(" + (this.state.hotel && this.state.hotel.wifi_welcome_settings.background_url) + ")";
    }
    if(this.state.hotel && this.state.hotel.wifi_welcome_settings.fav_url !== "") {
      $("link[rel='shortcut icon']").attr("href", this.state.hotel.wifi_welcome_settings.fav_url);
    }

    if (this.state.hotel_id == 'radisson-red-brussels') {
      require('./misc/styles/radison.css');
      return (
        <Radison />
      );
    } else {
      if (this.state.hotel && this.state.hotel.wifi_welcome_settings.background_color)
        document.querySelector('#root').style.setProperty('background-color', this.state.hotel.wifi_welcome_settings.background_color, 'important');
      let showHeader = this.checkElementValue("name:showHeader,valueTrue:true");
      return (
        <React.Fragment>
          { this.state.through_qr || this.state.is_qr ? this.renderContent() :
          <div style={{ paddingTop: showHeader? '0': '3%' }}>
            {showHeader && <Header hotelColor={(this.state.hotel && this.state.hotel.wifi_welcome_settings.color)} hotelLogo={(this.state.hotel && this.state.hotel.wifi_welcome_settings.logo_url)} />}
            <div className="container">
                {this.renderContent()}
            </div>
            <Footer termsUrl={(this.state.hotel && this.state.hotel.wifi_welcome_settings.terms_url)} />
          </div>
          }
        </React.Fragment>
      );
    }
  }
}

export default App;
